import { useTranslate } from "@refinedev/core";
import {
  Box,
  Button,
  Grid2 as Grid,
  IconButton,
  Popover,
  Typography,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { Form } from "@shared/components";
import { useState } from "react";
import { useFormContext } from "react-hook-form";

export function Step2() {
  const translate = useTranslate();

  const [anchorEl, setAnchorEl] = useState<any>(null);
  const [popoverContent, setPopoverContent] = useState<any>(null);

  const handlePopoverOpen = (event: any, content: any) => {
    setAnchorEl(event.currentTarget);
    setPopoverContent(content);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setPopoverContent(null);
  };
  const isPopoverOpen = Boolean(anchorEl);

  const watch = useFormContext().watch;

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="slug"
          label={translate("v1/agreement_app_admin.fields.slug")}
          instructions={translate("v1/agreement_app_admin.instructions.slug")}
          fullWidth
        />
      </Grid>

      <Box>
        <Typography>
          Certifique-se que as builds foram completadas
          <IconButton
            onClick={(e) =>
              handlePopoverOpen(e, {
                title: "Link para as builds",
                link: `https://expo.dev/accounts/partiu.vantagens/projects/${watch(
                  "slug"
                )}/builds`,
                image: "/images/create-app/expo-builds.png",
              })
            }
            size="small"
            sx={{ ml: 1 }}
          >
            <InfoIcon color="primary" />
          </IconButton>
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Typography variant="h5" mb={2}>
            Android
          </Typography>
          <Typography>
            Clique na build mais recente e clique em download. Um arquivo .aab
            será baixado.
          </Typography>
          <Typography>
            Entre em{" "}
            <Button
              variant="text"
              href="https://play.google.com/console/u/0/developers"
              target="_blank"
              rel="noreferrer"
            >
              Google Play Developer Console
            </Button>{" "}
            e crie um novo app.
          </Typography>
          <Typography>
            Configure a loja e adicione uma nova versão com o arquivo .aab no
            teste interno.
            <IconButton
              onClick={(e) =>
                handlePopoverOpen(e, {
                  title: "Teste interno",
                  image: "/images/create-app/teste-interno.png",
                })
              }
              size="small"
              sx={{ ml: 1 }}
            >
              <InfoIcon color="primary" />
            </IconButton>
          </Typography>
          <Typography>
            Após adicionar para teste interno, avise a equipe para testar.
          </Typography>
        </Box>
        <Box sx={{ mt: 2 }}>
          <Typography variant="h5" mb={2}>
            iOS
          </Typography>
          <Typography>
            Crie um novo app na Apple Store Connect com o Bundle ID escolhido.
            <IconButton
              onClick={(e) =>
                handlePopoverOpen(e, {
                  title: "App Store Connect",
                  link: "https://appstoreconnect.apple.com/apps",
                  image: "/images/create-app/new-app.png",
                })
              }
              size="small"
              sx={{ ml: 1 }}
            >
              <InfoIcon color="primary" />
            </IconButton>
          </Typography>
          <Typography>
            Após a criação, localize o App ID.
            <IconButton
              onClick={(e) =>
                handlePopoverOpen(e, {
                  title: "App ID",
                  image: "/images/create-app/appid.png",
                })
              }
              size="small"
              sx={{ ml: 1 }}
            >
              <InfoIcon color="primary" />
            </IconButton>
          </Typography>
        </Box>
      </Box>

      <PopoverComponent
        isPopoverOpen={isPopoverOpen}
        anchorEl={anchorEl}
        handlePopoverClose={handlePopoverClose}
        popoverContent={popoverContent}
      />

      <Grid size={{ xs: 12 }}>
        <Form.Input name="app_id" label={"App ID da apple"} fullWidth />
      </Grid>
    </Grid>
  );
}

export const PopoverComponent = ({
  isPopoverOpen,
  anchorEl,
  handlePopoverClose,
  popoverContent,
}: {
  isPopoverOpen: boolean;
  anchorEl: any;
  handlePopoverClose: () => void;
  popoverContent: any;
}) => {
  return (
    <Popover
      open={isPopoverOpen}
      anchorEl={anchorEl}
      onClose={handlePopoverClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <Box sx={{ p: 2, width: 500 }}>
        {popoverContent?.title && (
          <Typography variant="h6" gutterBottom>
            {popoverContent.link ? (
              <Button
                variant="text"
                href={popoverContent.link}
                target="_blank"
                rel="noreferrer"
              >
                {popoverContent.title}
              </Button>
            ) : (
              popoverContent.title
            )}
          </Typography>
        )}
        {popoverContent?.description && (
          <Typography variant="caption" gutterBottom>
            {popoverContent.description}
          </Typography>
        )}

        {popoverContent?.image && (
          <Box sx={{ mt: 2 }}>
            <img
              src={popoverContent.image}
              alt={popoverContent.title || "Imagem"}
              style={{ width: "100%", objectFit: "contain" }}
            />
          </Box>
        )}
      </Box>
    </Popover>
  );
};
